<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
     
      <v-card>
        <v-card-title>
          <span class="headline">DMI Search</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>

              <v-col cols="12" class="py-0" sm="6" md="6">
                <v-text-field
                  label="VME DMI Number"
                  dense outlined v-model="dados.internalId"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="py-0" sm="6" md="6">
                <v-text-field
                  label="Airline DMI number"
                  dense outlined v-model="dados.airline_dmi_no"
                ></v-text-field>
              </v-col>

              <v-col
                cols="12"
                sm="6"
                md="6"
                 class="py-0"
              >
              <v-autocomplete dense outlined  v-model="dados.reg_no" label="Reg Number" :items="$store.state.acInformation" item-text="reg_no" item-value="reg_no">
              </v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                 class="py-0"
              >
              <v-autocomplete dense outlined  v-model="dados.ata" label="Ata" :items="$store.state.ata" item-text="chapter" item-value="chapter">
                <template v-slot:item="{ item }">
                 <v-list-item-content>
                     {{item.chapter}} - {{item.designation}}
                  </v-list-item-content>
                </template>
              </v-autocomplete>
              </v-col>


              <v-col cols="12" class="py-0 mb-2"><h3 class="py-0">Open Date</h3></v-col>           
              <v-col cols="12" sm="6" class="py-0">
                <v-text-field
                  label="Date From (GMT)"
                  type="date"
                  dense outlined
                  v-model="dados.openFrom"
                ></v-text-field>
              </v-col>
             
              <v-col cols="12" sm="6" class="py-0">
                <v-text-field
                  label="Date To (GMT)"
                  type="date"
                  dense outlined
                  v-model="dados.openTo"
                ></v-text-field>
              </v-col>
              
              <v-col cols="12" class="py-0"><h3 class="py-0 mb-2">Complete Date</h3></v-col>           
              <v-col cols="12" sm="6" class="py-0">
                <v-text-field
                  label="Date From (GMT)"
                  type="date"
                  dense outlined
                  v-model="dados.completeFrom"
                ></v-text-field>
              </v-col>
             
              <v-col cols="12" sm="6" class="py-0">
                <v-text-field
                  label="Date To (GMT)"
                  type="date"
                  dense outlined
                  v-model="dados.completeTo"
                ></v-text-field>
              </v-col>


               <v-col cols="12" sm="12" md="12" class="py-0">
                <v-text-field
                  label="Key Word"
                  dense outlined
                  v-model="dados.key_word"
                ></v-text-field>
              </v-col>
              

            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="$store.state.dialog = false, clear()"
          >
            Close
          </v-btn>
          <v-btn
            color="success darken-1"
            elevation="0"
            @click=" retrieveAll()"
          >
            Retrieve All
          </v-btn>
          <v-btn
            color="info darken-1"
            elevation="0"
            @click=" retrieve()"
          >
            Retrieve
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {

    data: () => ({
      /* dialog: false, */
      dados:{
        internalId:'',
        reg_no:'',
        airline_dmi_no:'',
        openFrom:'',
        openTo:'',
        completeFrom:'',
        completeTo:'',
        ata:'',
        key_word:'',
      }
    }),
    methods:{
      clear(){
        this.dados = {
        internalId:'',
        reg_no:'',
        airline_dmi_no:'',
        openFrom:'',
        openTo:'',
        completeFrom:'',
        completeTo:'',
        ata:'',
        key_word:'',
      };
      },
      retrieve(){
        this.$store.dispatch("filterDMI", this.dados);

        this.$store.state.dialog = false;
      },
      retrieveAll(){
        this.$store.dispatch("getDmiRequestO");

        this.$store.state.dialog = false;
      }
    },
    computed:{
      dialog(){
        return this.$store.state.dialog;
      }
    }
  }
</script>
